<script>
/**
 * Hints page - now uses HintsPage component with composition API
 * This file serves as an alias for backward compatibility
 */
import HintsPage from './HintsPage.vue';
export default HintsPage;
</script>
